import { ProgramInfo, SubProgramDescription } from "@interfaces/program"
import { ServiceInfo } from "@interfaces/services"
import ProgramRepositories from "../repositories/program.repositories"
import { Result } from "./result"

export default class ProgramServices extends ProgramRepositories {
  async getPrograms() {
    try {
      const res = await this.getRawPrograms()

      const { result, error } = await this._getResponse<ProgramInfo[]>(res)

      if (error || !result) {
        return Result.fail<ProgramInfo[]>()
      }

      const programs = result.map((p) => {
        return this._swaggerResponseSpreader<any>(p)
      })

      const programData = programs.map((d) => {
        return {
          ...d,
          services: d.services ? this._swaggerDataSpreader<ServiceInfo>(d.services) : [],
          programSubDescriptions: d.tags
            ? this._swaggerDataSpreader<SubProgramDescription>(d.tags)
            : [],
        }
      })

      return Result.ok<ProgramInfo[]>(programData)
    } catch (error) {
      return Result.fail<ProgramInfo[]>()
    }
  }
}
